export enum AgronomyChartPosition {
 Left = 1,
 Right = 2
}

// The seed categories in the database are created with these Id's and will always
// have the same Id across deployments.
export enum SeedCategory {
  Alfalfa = 1,
  Canola = 2,
  Corn = 3,
  Cotton = 4,
  Sunflower = 5,
  SoftRedWinterWheat = 6,
  Silage = 7,
  ForageSorghum = 8,
  GrainSorghum = 9,
  SudangrassSorghum = 10,
  SoybeansOver3_5RM = 11,
  SoybeansUnder3_5RM = 12,
  HardRedSpringWheat = 13,
  HardRedWinterWheat = 14,
  SoftWhiteWinterWheat = 15,
  Rice = 16,
  Mustard = 17,
  Barley = 18,
  DurumWheat = 19,
  Flax = 20,
}


// WEBPACK FOOTER //
// ./src/infrastructure/enums.ts